<template>
  <div>
    <HeaderComponent />
    <FeatureSection />
    <IaSection />
    <HeroSection />
    <AdvantageSection />
    <TestimonialSection />
  </div>
</template>

<script>
import { useMeta } from "vue-meta";
import HeaderComponent from "@/components/home/HeaderComponent.vue";
import HeroSection from "@/components/home/HeroSection.vue";
import FeatureSection from "@/components/home/FeatureSection.vue";
import TestimonialSection from "@/components/home/TestimonialSection.vue";
import IaSection from "@/components/home/IaSection.vue";
import AdvantageSection from "@/components/home/AdvantageSection.vue";

export default {
  mounted() {
    import("@/assets/globalJs/global.js").then((module) => {
      const { observeElements } = module;
      observeElements(
        ".slide-right",
        ".slide-left",
        ".fall-down",
        ".image-fade-in"
      );
    });
  },
  components: {
    HeaderComponent,
    HeroSection,
    FeatureSection,
    IaSection,
    TestimonialSection,
    AdvantageSection,
  },
  setup() {
    useMeta({
      title: "Livratos – Livraison sur chantier pour le BTP",
      description: [
        {
          content:
            "Livratos est la plateforme de livraison sur chantier dédiée au BTP. Fournisseurs de matériaux, artisans et livreurs indépendants organisent leurs livraisons simplement : missions de livraison BTP, transport de matériel sur chantier et suivi en temps réel partout en France.",
        },
      ],
      link: [
        {
          rel: "canonical",
          href: "https://www.livratos.fr",
        },
      ],
    });
  },
};
</script>

<style>
/* Ajouter des styles globaux ici si nécessaire */
</style>
